import { z } from 'zod';

/** Everything the app needs from its environment. Served as /config.js at runtime, never baked into the bundle. */
export const GROWTHBOOK_API_HOST = 'https://growthbook-api.prod.alto.com';

/** The API's account roles, restated because this package does not depend on the app's generated client. */
const DEV_ACCOUNT_ROLES = ['prescriber', 'office_staff', 'aes'] as const;

export const appConfigSchema = z
  .object({
    environment: z.enum(['local', 'sandbox', 'staging', 'prod']),
    /** Prefix for every API path: '/api' behind the dev proxy, or the API origin, e.g. https://fuze-portals-api.dev.pharmacy.fuzehealth.com */
    apiBaseUrl: z.string().default(''),
    sentryDsn: z.url().optional(),
    // One GrowthBook instance serves every Fuze app (GROWTHBOOK_API_HOST); only the SDK client key varies per app and environment.
    growthbookClientKey: z.string().min(1).optional(),
    /**
     * TODO: delete once fuze-portals-api's `GET /me` returns the portal account. Today it never does and `createAccount`
     * (the NPI step's Continue) is a 501 stub, so nobody gets past the NPI step. Dev sets this: a signed-in
     * user without an account is treated as having one with this role. Refused in prod.
     */
    devAccountRole: z.enum(DEV_ACCOUNT_ROLES).optional(),
  })
  .refine((config) => config.environment !== 'prod' || config.devAccountRole === undefined, {
    path: ['devAccountRole'],
    message: 'must not be set in prod',
  });

export type AppConfig = z.infer<typeof appConfigSchema>;
